import React, { useEffect, useContext, useState } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import * as API from '../utils/APICalls'
import * as helpers from '../utils/helpers'
import { AppContext } from "../context/AppProvider";
import CloseButton from './CloseButton';
import { DataGrid } from '@mui/x-data-grid'
import {
  Box, Button, Card, Container, Divider, IconButton, Input, InputAdornment,
  List, ListItem, ListItemIcon, MenuItem, Paper, Select, Stack, Switch, Pagination, Tooltip, Typography
} from '@mui/material';
import Events from '../views/storefrontComponents/musicPlayer/Events';
import Listeners from './Listeners';
import { MusicManager } from './MusicManager';
const ArtistConsole = () => {

  const { appData, updateAppData, modalOpen, userData, shops,
    setShops, orders, setOrders,
    setModalSubView, modalSubView, currentCart, setCurrentCart,
    currentShop, currentArtist, setCurrentArtist,
    subView, setSubView,
    currentProduct } = useContext(AppContext)
  const subViews = ['listeners', 'events', 'music', 'sales', 'subs']
  const [bookingNotifs, setBookingNotifs] = useState(0)
  const [events, setEvents] = useState()

  useEffect(() => {

  }, [bookingNotifs, events])


  useEffect(() => {

    const fetchBookings = async () => {
      try {
        const bookings = await API.fetchBookings(currentArtist?._id)
        if (bookings) {
          setEvents(bookings)
          const confirmedBookings = bookings.filter((b, i) => b?.isConfirmed)
          const reviewedBookings = bookings.filter((b, i) => b?.isReviewed)
          setBookingNotifs(bookings?.length - reviewedBookings?.length)

        }
      } catch (err) {
        console.log('Error Fetching Bookings', err)
      }
    }
    fetchBookings()
  }, [])

  return (
    <Container sx={{
      position: 'relative',//border:'1px solid red',
      padding: '0.5rem',
      maxHeight: '95vh',
      minHeight: '80vh',
      fontFamily: 'Gilroy, sans-serif',
      //  margin:'auto',
      width: '100%'
    }}>
      <div style={{ position: 'absolute', top: '0.5rem', right: '0.5rem' }}>
        <CloseButton func={updateAppData} val={{
          modalOpen: !modalOpen,
          modalView: ''
        }} />
      </div>
      <ArrowBackIcon style={{
        fontSize: '2rem',//position:'absolute',
        left: '2rem', cursor: 'pointer', opacity: '0.5', zIndex: 9999,
        top: '0.5rem', marginTop: '0.5rem'
      }}
        onClick={() => {
          if (subView === 'review-event' && currentCart) {
            setSubView('events')
          }
          //   else if(subView === 'review-cart'){
          //     setSubView('carts')
          //   }else if(subView === 'review-order' && ! currentCart){
          //     setSubView('orders')
          else {
            //   // setSubView('review-cart') 
            updateAppData({
              ...appData,
              modalView: 'artists'
            })
          }
        }}

      />

      <Typography>  <h2> {currentShop?.operating_name}</h2>Artist Console</Typography>
      <Paper
        sx={{
          position: 'relative', display: 'flex',
          flexDirection: 'column', width: '100%', padding: '1rem 0',
          boxShadow: '0px 0px 5px 1px rgba( 0, 0, 0 , 0.3 )',
          maxWidth: '100%',
          minHeight: '50vh', margin: '2rem åauto', maxHeight: '70vh',
          overflow: 'hidden',//overflowY:'scroll',
          borderRadius: '10px', border: '1px solid #757575'
        }}
        onClick={() => {
          // handleShopClick()
        }}>
        <Box
          sx={{
            gap: '0.5rem', justifyContent: 'space-evenly',
            padding: '0.5rem 0',
            width: '100%', textAlign: 'center'
          }}
        >

          <Stack sx={{
            display: 'flex', flexDirection: 'row', width: '100%',

            justifyContent: 'space-evenly', marginBottom: '1rem'
          }}>
            {subViews?.map((view, i) => {
              return (
                <b key={i} style={{
                  flexWrap: 'wrap', display: 'flex', gap: '0.25rem', alignItems: 'center',
                  cursor: 'pointer', borderBottom: subView === view ? '1px solid #757575' : ''
                }} onClick={() => {
                  setSubView(view)
                  updateAppData({
                    ...appData,
                    modalSubView: view
                  })
                }}>
                  {view}
                  {view === 'listeners' && <div style={{ fontSize: '0.65rem', fontWeight: "normal" }}></div>}
                  {view === 'music' && <div style={{ fontSize: '0.65rem', fontWeight: "normal" }}></div>}
                  {view === 'events' && <div style={{ fontSize: '0.65rem', fontWeight: "normal" }}>( {bookingNotifs} )</div>}
                  {view === 'subs' && <div style={{ fontSize: '0.65rem', fontWeight: "normal" }}>( {currentArtist?.subscribers?.length} )</div>}

                </b>
              )
            })}
          </Stack>

          <Divider />

        </Box>
        {subView === 'events' && <>
          {/* { events?.length > 0 ?  */}
          <Events artist={currentArtist} view='console' />
          {/* <span> No Events Listed.</span>} */}
        </>
        }
        {subView === 'listeners' && <>
          {/* Listeners/ subs / plays / */}
          <Listeners artist={currentArtist} view='console' />
        </>
        }
        {subView === 'music' && <>
          <MusicManager artist={currentArtist} />

        </>
        }
        {subView === 'sales' && <>
          {/*tracking */}
        </>
        }
      </Paper>
    </Container>
  )
}

export default ArtistConsole